import {uuid} from 'uuidv4';
import Automations from './Automations.js';
import {index} from './ParameterIndex.js';

export default class BaseParameter {
    static getDefaultConfig(config) {
        if (config.min === undefined) {
            config.min = 0;
        }
        if (config.max === undefined) {
            config.max = 1;
        }
        if (config.max === undefined) {
            config.units = '';
        }
        if (config.defaultValue === undefined) {
            config.defaultValue = 0;
        }
        if (config.automatable === undefined) {
            config.automatable = true;
        }
        if (config.uxAutomatable === undefined) {
            config.uxAutomatable = true;
        }
        if (config.constantAutomationRate === undefined) {
            config.constantAutomationRate = false;
        }
        return config;
    }

    constructor(name, object, setter, config={}) {
        config = BaseParameter.getDefaultConfig(config);
        this.config = config;
        this.hide = this.config.hide;
        this.isParameter = true;
        this.isAlwaysLocked = config.isAlwaysLocked;
        this.toCache = {};
        this.fromCache = {};

        // store the parameters

        this.isDb = config.isDb;

        // the ParameterContext for this AbstractParameter, this
        // tells us where this parameter comes from, i.e. an effect/track/group etc
        this.context = undefined;
        this.name = name;
        this.prettyName = config.prettyName || name;
        this.effectName = undefined;

        this.builder = config.builder;

        // object that contains this parameter (i.e. an effect object,
        // StepData object, or AudioParam)
        this.object = object;

        // setter is a function that sets the object
        this.setter = setter;

        // the minimum accepted (not enforced) value for this parameter
        this.min = config.min;

        this.useMeter = false;

        // the maximum accepted (not enforced) value for this parameter
        this.max = config.max;

        // whether we are allowed to modify the AudioParam.automationRate 
        this.constantAutomationRate = config.constantAutomationRate;

        // the units (i.e. HZ) for a value
        this.units = config.units;
        this.unlockedValue = null;
        this.automatable = config.automatable;
        this.uxAutomatable = config.uxAutomatable;

        // each pattern in a sequence may have different values for the parameter
        // so this map keeps track of which patterns have which locked value
        this.patternToValue = {};
        this.paletteToValue = {};

        // keep track of id
        this.id = uuid();

        if (config.defaultValue !== null) {
            this.set(config.defaultValue, true, true);
        }

        this.originalMin = this.min;
        this.originalMax = this.max;

        this.store = undefined;
        this.context = undefined;
        this.mixSession = undefined;
        this.lfos = [];
        this.envelopes = [];

        this.patternToAutomation = {};
        this.unlockedAutomation = new Automations(this);
        this.mixAutomation = new Automations(this, true);
        this.previousAutomation = this.unlockedAutomation;
        this.currentStep = undefined;

        this.keyScaling = undefined;
    }
}
